import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConnectedShopMovie, ConnectedShow, DataApiResponse, MovieShowType } from '@digilize/shared/definitions/src';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MovieShowTypesApiService {
  constructor(private http: HttpClient) {}
  readonly BASE_URL = '/api/v1.0/movie-show-types';

  getActive(params?): Observable<DataApiResponse<MovieShowType[]>> {
    return this.http.get<DataApiResponse<MovieShowType[]>>(`${this.BASE_URL}`, { params });
  }

  getArchived(params?): Observable<DataApiResponse<MovieShowType[]>> {
    return this.http.get<DataApiResponse<MovieShowType[]>>(`${this.BASE_URL}/archived`, { params });
  }

  getType(id: string): Observable<MovieShowType> {
    return this.http.get<MovieShowType>(`${this.BASE_URL}/${id}`);
  }

  addType(type: Partial<MovieShowType>): Observable<MovieShowType> {
    return this.http.post<MovieShowType>(`${this.BASE_URL}`, type);
  }

  editType(type: MovieShowType): Observable<MovieShowType> {
    return this.http.put<MovieShowType>(`${this.BASE_URL}/${type.id}`, type);
  }

  deleteType(id: string): Observable<void> {
    return this.http.delete<void>(`${this.BASE_URL}/${id}`);
  }

  archive(id: string): Observable<void> {
    return this.http.post<void>(`${this.BASE_URL}/${id}/archive`, {});
  }

  unarchive(id: string): Observable<void> {
    return this.http.post<void>(`${this.BASE_URL}/${id}/unarchive`, {});
  }

  getConnectedShows(id: string, params?): Observable<DataApiResponse<ConnectedShow[]>> {
    return this.http.get<DataApiResponse<ConnectedShow[]>>(`${this.BASE_URL}/${id}/shows`, { params });
  }

  getConnectedMovies(id: string, params?): Observable<DataApiResponse<ConnectedShopMovie[]>> {
    return this.http.get<DataApiResponse<ConnectedShopMovie[]>>(`${this.BASE_URL}/${id}/movies`, { params });
  }

  // DELETE with a body: HttpClient.delete supports it, but request() states the intent plainly.
  detachShows(id: string, showIds: string[]): Observable<void> {
    return this.http.request<void>('delete', `${this.BASE_URL}/${id}/shows`, { body: { show_ids: showIds } });
  }

  detachMovies(id: string, shopMovieIds: string[]): Observable<void> {
    return this.http.request<void>('delete', `${this.BASE_URL}/${id}/movies`, {
      body: { shop_movie_ids: shopMovieIds },
    });
  }
}
